import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { ROUTES } from '../../config/routes';
import type { UserRole } from '../../models/enums';
import { useAuth } from '../../hooks/useAuth';
import { Spinner } from '@fluentui/react-components';

export const ProtectedRoute = ({ children, allowedRoles }: { children: ReactNode; allowedRoles?: UserRole[] }) => {
  const { isAuthenticated, isLoading, role } = useAuth();
  if (isLoading) return <Spinner label="Loading CRM workspace..." />;
  if (!isAuthenticated) return <Navigate to={ROUTES.LOGIN} replace />;
  if (allowedRoles && !allowedRoles.includes(role)) return <Navigate to={ROUTES.UNAUTHORIZED} replace />;
  return <>{children}</>;
};
